import { ToggleRight } from '@phosphor-icons/react';

export default ToggleRight;
